<template>
  <div>
    <back-box :id="this.$route.query.titleBarId" :front="this.typeId"></back-box>
    <div class="content">
      <title-bar class="titleBar" :title="'筛选条件'"></title-bar>
      <p>
        <span class="title">创建者:&nbsp;</span>
        <a class="power people_select" @click="toChoose(1,true)">
          <span>{{ peopleValue1 }}</span>
        </a>
      </p>
      <p>
        <span class="title">任务关键词检索&nbsp;:&nbsp;</span>
        <el-input
          type="input"
          class="search"
          size="small"
          v-model="keyword"
          placeholder="请输入关键词"
        >
        </el-input>
      </p>
      <button class="button" @click="toRecord">{{ buttonText[typeId] }}</button>
    </div>
  </div>
</template>

<script>
  import header from "@/views/Security/subcomponents/header";
  import titleBar from "@/views/Security/subcomponents/titleBar";
  let moment = require('moment');
  export default {
    data(){
      return{
        wxtoken: "",
        //判别
        typeId: this.$route.query.typeId,//模块
        titleTarId: 0,//导航栏
        recordType: 0,//记录入口类型
        //数据仓库
        buttonText:{
          1 : "查询检查任务单",
          2 : "查询任务",
          3 : "查询任务",
          4 : "查询任务",
          5 : "查询任务",
          6 : "查询任务",
        },
        people:{
          1 : "检查人员",
          2 : "培训老师",
          3 : "",
          4 : "巡检人",
          5 : "主持人",
          6 : ["监护人","解除人"]
        },
        time:{
          1 : "整改",
          2 : "任务",
          3 : "任务",
          4 : "任务",
          5 : "任务",
          6 : "任务",
        },
        //日期选择器相关
        isVisible: false,
        date: null,
        dateWeek: null,
        date1: [],
        //输入框绑定变量
        powerValue: '',//权限
        peopleValue1: '请选择',
        people1Id: null,
        peopleValue2: '请选择',
        people2Id: null,
        keyword: '',
        trainTeacher: ''
      }
    },
    mounted() {

    },
    created() {
      //缓存输入
      this.getSessionStorage()
      //选人数据处理
      this.getcheckListStr()
    },
    methods:{
      changeVisible(){
        this.isVisible = true;
      },
      //跳往选人页面
      toChoose(boxId,singleSwitch){
        //跳转前缓存输入
        let queryList = {
          startDate: this.date1[0],
          endDate: this.date1[1],
          power: this.powerValue,
          peopleValue1: this.peopleValue1,
          peopleValue2: this.peopleValue2,
          people1Id: this.people1Id,
          people2Id: this.people2Id,
          keyword: this.keyword,
          trainTeacher: this.trainTeacher
        }
        sessionStorage.setItem("query", JSON.stringify(queryList))
        this.$router.push({ name: 'choosePerson', query: { titleId: 26, singleSwitch:singleSwitch, front: {name: 'security_allquery', typeId: this.typeId,titleBarId: this.$route.query.titleBarId, chooseId: boxId, checkData:null}}})
      },
      //缓存输入
      getSessionStorage(){
        this.typeId = sessionStorage.getItem('typeId')
        if (!this.typeId){
          this.typeId = this.$route.query.typeId
        }
        let queryList = JSON.parse(sessionStorage.getItem('query'));
        if (queryList) {
          this.powerValue = queryList.power;
          this.date1[0] = queryList.startDate;
          this.date1[1] = queryList.endDate;
          if (queryList.peopleValue1) {
            this.peopleValue1 = queryList.peopleValue1;
          } else {
            this.peopleValue1 = "请选择";
          }
          if (queryList.peopleValue2) {
            this.peopleValue2 = queryList.peopleValue2;
          } else {
            this.peopleValue2 = "请选择";
          }
          this.people1Id = queryList.people1Id;
          this.people2Id = queryList.people2Id;
          this.keyword = queryList.keyword;
          this.trainTeacher = queryList.trainTeacher
        }
      },
      //选人数据处理
      getcheckListStr(){
        if (this.$route.query.checkUserList) {
          if (this.$route.query.chooseId == 1) {
            this.peopleValue1 = this.$route.query.checkUserList[0].username
            this.people1Id = this.$route.query.checkUserList[0].id
          } else {
            this.peopleValue2 = this.$route.query.checkUserList[0].username
            this.people2Id = this.$route.query.checkUserList[0].id
          }
        }
      },
      //跳往记录页，携带输入数据
      toRecord(){
        // 移除session的query数据
        sessionStorage.removeItem("query");
        // 跳转到查看记录列表页
        this.$router.push({
          name: 'security_viewrecord', query: {
            titleBarId: 29, typeId: this.typeId, remindSwitch: 1, recordType: 6, query: {
              startDate: this.date1[0],
              endDate: this.date1[1],
              power: this.powerValue,
              people1: this.people1Id,
              people2: this.people2Id,
              keyword: this.keyword,
              trainTeacher: this.trainTeacher
            }
          }
        })
      }
    },
    components:{
      "back-box" : header,
      "titleBar" : titleBar,
    }
  }
</script>

<style lang="scss" scoped>
  .content{
    padding: 20px;
    .title-bar{
      margin-bottom: 20px;
    }
    p{
      margin-bottom: 30px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .title{
      font-size: 16px;
      font-weight: 700;
      margin-left: 10px;
      white-space: nowrap;
    }
    .power{
      width: 70%;
    }
    .people_select{
      display: inline-block;
      box-sizing: border-box;
      font-size: 14px;
      border: 1px solid #DCDFE6;
      border-radius: 4px;
      padding: 8px 8px 8px 14px;
      color: #606266;
    }
    .danger{
      width: 27%;
    }
    .transition{
      font-weight: 700;
      color: #BEB8B8;
      margin: 0 4px;
      font-size: 14px;
      flex-shrink: 1;
      flex-grow: 1;
      flex-basis: 18px;
    }
    .border{
      border-radius: 4px;
      padding: 6px;
      font-size: 14px;
      border: 1px solid #DCDFE6;
      flex-shrink: 1;
      flex-grow: 1;
      flex-basis: 88px;
      white-space: nowrap;
    }
    .search{
      width: 56%;
    }
    .button{
      font-weight: 700;
      font-size: 18px;
      display: block;
      border: none;
      width: 86%;
      height: 49px;
      margin: 0 auto;
      color: #FFFFFF;
      background-color: #00CC33;
      border-radius: 4px;
    }
    .leader{
      margin-left: 18px;
    }
    .time_displayer{
      display: flex;
      align-items: center;
    }
  }
</style>
